import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  OnDestroy,
  OnChanges,
  SimpleChanges,
  ElementRef,
  ViewChild,
  Renderer2,
  AfterViewInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { differenceInSeconds, parseISO } from 'date-fns';

@Component({
  selector: 'status-loader',
  templateUrl: './notebook-status-loader.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotebookStatusLoaderComponent implements OnDestroy, OnChanges, AfterViewInit {
  @Input() createdAt!: string | Date;
  @Input() simple?: string;
  @Input() pulseOnly?: string;
  @Input() targetPercent?: number;
  @Input() targetSeconds?: number;

  @ViewChild('progressBar', { static: false })
  progressBar!: ElementRef;

  private activeTimeout: any;
  private currentValue: Date | null = null;
  percent = 0;
  constructor(private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    this.updateCreatedAt();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['createdAt']) {
      this.updateCreatedAt();
    }
  }

  ngOnDestroy(): void {
    this.cancelTimer();
  }

  private updateCreatedAt(): void {
    if (!this.createdAt) {
      this.cancelTimer();
      this.currentValue = null;
      return;
    }

    this.currentValue = typeof this.createdAt === 'string' ? parseISO(this.createdAt) : this.createdAt;

    this.cancelTimer();

    if (this.currentValue) {
      this.updateTime(this.currentValue);
    }
  }

  private updateTime(currentValue: Date): void {
    const now = new Date();
    const seconds = differenceInSeconds(now, currentValue);
    const tPercent = (this.targetPercent ?? 75) / 100;
    const tSeconds = this.targetSeconds ?? 30;
    const percent = Math.min(96, ((Math.log10(seconds) * tPercent) / Math.log10(tSeconds)) * 100);
    this.percent = percent;
    if (this.progressBar) {
      this.renderer.setStyle(this.progressBar.nativeElement, 'width', `${percent}%`);
    }

    this.activeTimeout = setTimeout(() => {
      this.updateTime(currentValue);
    }, 1000);
  }

  private cancelTimer(): void {
    if (this.activeTimeout) {
      clearTimeout(this.activeTimeout);
    }
  }
}
